// @flow
import {
  SET_USER_GRAPHQL, SET_AUTH,
  SET_LOGINS, SET_FETCHING_AUTH, UPDATE_USER,
  UPDATE_USER_LICENCE,
  ADD_TAB, SET_STEP
} from "../../global/actions/actionNames";

const initialState = {
  fetchingAuth: false,
  auth: null,
  logins: {},
  step: null,
  tabs: []
};

const userReducers = (state: Object = initialState, actions: Object): * => {
  switch (actions.type) {
  case SET_AUTH:
    if (actions.authenticated !== null) {
      return {
        ...state,
        auth: actions.authenticated
      };
    }
    return state;

  case SET_FETCHING_AUTH:
    if (actions.status !== null) {
      return {
        ...state,
        fetchingAuth: actions.status
      };
    }
    return state;

  case SET_LOGINS:
    if (actions.logins !== null) {
      return {
        ...state,
        logins: actions.logins
      };
    }
    return state;
  
  case SET_USER_GRAPHQL:
    if (actions.user !== null) {
      return {
        ...state,
        ...actions.user
      };
    }
    return state;

  case UPDATE_USER:
    if (actions.field !== null && actions.value !== null) {
      return {
        ...state,
        [actions.field]: actions.value
      };
    }
    return state;

  case UPDATE_USER_LICENCE:
    if (actions.data !== null && actions.data.id !== null) {
      let licences = [...state.licences.edges];
      let facebaseID = state.defaultFacebase.id;
      if(licences.length > 0) {
        let index = licences.findIndex(x => x.node.id === actions.data.id);
        if(index > -1){
          licences[index].node = actions.data;
        }
        else{
          if(facebaseID === actions.data.facebase.id){
            licences.push({"node": actions.data});
          }
        }
      }
      else{
        if(facebaseID === actions.data.facebase.id){
          licences.push({"node": actions.data});
        }
      }
      return {
        ...state,
        licences: {"edges": licences}
      };
    }
    return state;

  case ADD_TAB:
    if (actions.tab !== null) {
      let tabs = [...state.tabs];
      tabs.push(actions.tab);
      const oldStep = state.step;
      let newStep;
      if(oldStep === null) {
        newStep = 0;
      }
      else {
        newStep = oldStep + 1;
      }
      return {
        ...state,
        tabs: tabs,
        step: newStep
      };
    }
    return state;
  
  case SET_STEP:
    if (actions.step !== null) {
      let tabs = [...state.tabs];
      tabs.splice(actions.step + 1);
      return {
        ...state,
        tabs: tabs,
        step: actions.step
      };
    }
    return state;

  default:
    return state;
  }
};
export default userReducers;


